import React from 'react';
import PropTypes from 'prop-types';
import { NonIdealState, Spinner } from '@blueprintjs/core';

import { CenteredContainer } from '@f/components/shared/centered-container/CenteredContainer';

import cls from './LoadingScreen.module.css';

function LoadingScreen({ caption }) {
  return (
    <CenteredContainer>
      <NonIdealState className={cls.loader} icon={<Spinner />} title={caption} />
    </CenteredContainer>
  );
}

LoadingScreen.propTypes = {
  caption: PropTypes.string,
};

export default LoadingScreen;
